export default "__VITE_PUBLIC_ASSET__75714df7__"